module.exports = __webpack_public_path__ + "static/10.3_the_hebrew_kingdoms-b697467380604592fdcadd1bd0837642.pdf";